import { PageLayout } from '$components/common'
import { default as Timeclock } from '.'
import { RouteObject } from 'react-router-dom'

const basePath = '/time/timeclock'
export const timeclockRoutes: RouteObject[] = [
  {
    path: `${basePath}/staff-clocks`,
    element: (
      <PageLayout title={'Staff Clocks'}>
        <Timeclock.StaffClocks.Component />
      </PageLayout>
    ),
    loader: Timeclock.StaffClocks.Loader,
  },
  {
    path: `${basePath}/punches-by-staff`,
    element: (
      <PageLayout
        title={'Punches By Staff'}
        customBottomLeftComponent="ExportReportSelect"
      >
        <Timeclock.PunchesByStaff.Component />
      </PageLayout>
    ),
    loader: Timeclock.PunchesByStaff.Loader,
  },
]
